module.exports = __webpack_public_path__ + "static/whale-620a287df9956ba509c9bf9e6d5c0c45.svg";